import { render, staticRenderFns } from "./infoItem.vue?vue&type=template&id=1332e17f&scoped=true"
import script from "./infoItem.vue?vue&type=script&lang=js"
export * from "./infoItem.vue?vue&type=script&lang=js"
import style0 from "./infoItem.vue?vue&type=style&index=0&id=1332e17f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1332e17f",
  null
  
)

export default component.exports